import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function useScrollReveal() {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const ctx = gsap.context(() => {
            // Basic reveal - fade up
            gsap.utils.toArray('.reveal').forEach((item) => {
                gsap.fromTo(item,
                    { y: 40, opacity: 0 },
                    {
                        y: 0, opacity: 1,
                        duration: 0.7,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 88%',
                            toggleActions: 'play none none none',
                        }
                    }
                );
            });

            // Stagger children in product grids
            gsap.utils.toArray('.reveal-stagger').forEach((grid) => {
                const children = grid.children;
                if (children.length === 0) return;
                gsap.fromTo(children,
                    { y: 30, opacity: 0 },
                    {
                        y: 0, opacity: 1,
                        duration: 0.5,
                        stagger: 0.08,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: grid,
                            start: 'top 85%',
                            toggleActions: 'play none none none',
                        }
                    }
                );
            });

            // Reveal from left
            gsap.utils.toArray('.reveal-left').forEach((item) => {
                gsap.fromTo(item,
                    { x: -50, opacity: 0 },
                    {
                        x: 0, opacity: 1,
                        duration: 0.7,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 88%',
                        }
                    }
                );
            });

            // Reveal from right
            gsap.utils.toArray('.reveal-right').forEach((item) => {
                gsap.fromTo(item,
                    { x: 50, opacity: 0 },
                    {
                        x: 0, opacity: 1,
                        duration: 0.7,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 88%',
                        }
                    }
                );
            });

            // Scale reveal
            gsap.utils.toArray('.reveal-scale').forEach((item) => {
                gsap.fromTo(item,
                    { scale: 0.92, opacity: 0 },
                    {
                        scale: 1, opacity: 1,
                        duration: 0.6,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 88%',
                        }
                    }
                );
            });
        }, el);

        return () => ctx.revert();
    }, []);

    return ref;
}
